// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'mint-ui/lib/style.css';
import 'vue2-animate/dist/vue2-animate.min.css';
import Vue from 'vue'
import App from './App'
import router from './router'
import Mint from 'mint-ui'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store';
import axiosConfig from './service/config'
import ls from "./store/LStorage";
import { Indicator } from "mint-ui";
Vue.use(Mint)
Vue.use(VueAxios, axios)
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js